"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiGetFileUrlsResponse = instanceOfApiGetFileUrlsResponse;
exports.ApiGetFileUrlsResponseFromJSON = ApiGetFileUrlsResponseFromJSON;
exports.ApiGetFileUrlsResponseFromJSONTyped = ApiGetFileUrlsResponseFromJSONTyped;
exports.ApiGetFileUrlsResponseToJSON = ApiGetFileUrlsResponseToJSON;
exports.ApiGetFileUrlsResponseToJSONTyped = ApiGetFileUrlsResponseToJSONTyped;
const ApiS3URL_1 = require("./ApiS3URL");
/**
 * Check if a given object implements the ApiGetFileUrlsResponse interface.
 */
function instanceOfApiGetFileUrlsResponse(value) {
    if (!('urls' in value) || value['urls'] === undefined)
        return false;
    return true;
}
function ApiGetFileUrlsResponseFromJSON(json) {
    return ApiGetFileUrlsResponseFromJSONTyped(json, false);
}
function ApiGetFileUrlsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'urls': (json['urls'].map(ApiS3URL_1.ApiS3URLFromJSON)),
    };
}
function ApiGetFileUrlsResponseToJSON(json) {
    return ApiGetFileUrlsResponseToJSONTyped(json, false);
}
function ApiGetFileUrlsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'urls': (value['urls'].map(ApiS3URL_1.ApiS3URLToJSON)),
    };
}
